import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SegmentContainer } from '../../global.styles';
import { removeFavRental } from '../../redux/actions/rentalActions';
import { addItemToCart, toggleCartDropDown } from '../../redux/actions/cartActions';
import ItemsContainer from '../../components/collection-container/ItemsContainer';

const WishlistPage = ({ history }) => {
    
  const dispatch = useDispatch();
  const favRentals = useSelector((state) => state.rentals.favRentals);

  const handleClearRental = (id) => {
    dispatch(removeFavRental(id));
  };

  const handleAddRentalToCart = (rental) => {
    dispatch(addItemToCart(rental));
    dispatch(toggleCartDropDown());
  };

  const handleRidectToRental = (id) => {
    history.push(`/rentals/${id}`);
  };

  return favRentals.length > 0 ? (
    <SegmentContainer>
      <ItemsContainer
        items={favRentals}
        handleClearRental={handleClearRental}
        handleAddRentalToCart={handleAddRentalToCart}
        handleRidectToRental={handleRidectToRental}
      />
    </SegmentContainer>
  ) : (
    <SegmentContainer>
      <p> Please add items to your wishlist ! </p>
    </SegmentContainer>
  );
};

export default WishlistPage;
